import type { PublicApiKey } from '#packages/apilib';
import type { createMaskCropApi } from './maskCropWrapper';

export const MaskCropApiKey: PublicApiKey<typeof createMaskCropApi> = {
  name: 'MaskCropApi',
  public: true,
};
